export const instrumentoOptions = [
	{
		value: 'rubrica',
		label: 'Rúbrica',
		definicion:
			'Matriz que combina dimensiones de evaluación con niveles de logro e indicadores de desempeño específicos.'
	},
	{
		value: 'listaCotejo',
		label: 'Lista de cotejo',
		definicion: 'Lista de verificación que registra la presencia o ausencia de un desempeño o criterio determinado.'
	},
	{
		value: 'escalaValoracion',
		label: 'Escala de valoración',
		definicion:
			'Lista graduada que mide el nivel de desempeño en una dimensión específica según grados de presencia o calidad.'
	},
	{
		value: 'rubricaCualitativa',
		label: 'Matriz cualitativa',
		definicion:
			'Tabla flexible para crear evaluaciones cualitativas con campos de texto, ideal para retroalimentación, observación abierta, reflexión y otros usos.'
	}
];

export const optionsActividad = [
	{ value: 'grupal', label: 'De equipo' },
	{ value: 'individual', label: 'Individual' }
];

export const participantesOptions = [
	{
		value: 'individual',
		label: 'Instrumento individual',
		definicion:
			'El instrumento se aplica a cada estudiante por separado o cada estudiante coevalúa de manera independiente a otros compañeros, a su equipo o a otros equipos.'
	},
	{
		value: 'grupal',
		label: 'Instrumento de equipo',
		definicion:
			'El instrumento se aplica a cada equipo como conjunto o cada equipo coevalúa a compañeros u otros equipos.'
	}
];

export const modoAplicacionOptions = [
	{
		value: 'heteroevaluacion',
		label: 'Heteroevaluación',
		definicion: 'Uno o más docentes evalúan a estudiantes o equipos.'
	},
	{ value: 'autoevaluacion', label: 'Autoevaluación', definicion: 'Estudiantes o equipos se evalúan a sí mismos.' },
	{
		value: 'coevaluacion',
		label: 'Coevaluación',
		definicion: 'Estudiantes o equipos evalúan a compañeros del propio equipo, a otros equipos o al curso/grupo.'
	}
];

export const modalidadEvaluacionProfesorOptions = [
	{
		value: 'global',
		label: 'Global',
		definicion: 'El equipo docente responde el instrumento en conjunto.'
	},
	{
		value: 'individual',
		label: 'Individual',
		definicion: 'Cada docente del equipo responde el instrumento de manera individual.'
	}
];

export const modoCoevOptions = {
	individual: [
		{
			value: 'IndcoevaluacionInternaPorIntegrante',
			label: 'Coevaluación a compañeros de su equipo',
			definicion: 'De manera individual evalúa a compañeros de su propio equipo'
		},
		{
			value: 'IndautoevaluacionEquipo',
			label: 'Coevaluación a su equipo',
			definicion: 'De manera individual evalúa a su propio equipo'
		},
		{
			value: 'IndcoevaluacionIntegrantesOtroEquipo',
			label: 'Coevaluación a integrantes de otros equipos',
			definicion: 'De manera individual evalúa a integrantes de otros equipos'
		},
		{
			value: 'IndcoevaluacionEntreEquipos',
			label: 'Coevaluación a otros equipos',
			definicion: 'De manera individual evalúa a otros equipos'
		},
		{
			value: 'IndcoevaluacionCompanerosCurso',
			label: 'Coevaluación a compañeros de curso',
			definicion: 'De manera individual evalúa a compañeros de curso'
		}
	],
	grupal: [
		{
			value: 'GrucoevaluacionInternaPorIntegrante',
			label: 'Coevaluación a compañeros del equipo',
			definicion: 'En equipo evalúan a sus compañeros de equipo'
		},
		{
			value: 'GrucoevaluacionIntegrantesOtroEquipo',
			label: 'Coevaluación a integrantes de otros equipos',
			definicion: 'En equipo evalúan a integrantes de otros equipos'
		},
		{
			value: 'GrucoevaluacionEntreEquipos',
			label: 'Coevaluación a otros equipos',
			definicion: 'En equipo evalúan a otros equipos'
		},
		{
			value: 'GrucoevaluacionCompanerosCurso',
			label: 'Coevaluación a compañeros de curso',
			definicion: 'En equipo evalúan a compañeros de curso'
		}
	]
};

export enum MetodologiaRubricaEnum {
	IndcoevaluacionInternaPorIntegrante = 'IndcoevaluacionInternaPorIntegrante',
	IndautoevaluacionEquipo = 'IndautoevaluacionEquipo',
	IndcoevaluacionIntegrantesOtroEquipo = 'IndcoevaluacionIntegrantesOtroEquipo',
	IndcoevaluacionEntreEquipos = 'IndcoevaluacionEntreEquipos',
	IndcoevaluacionCompanerosCurso = 'IndcoevaluacionCompanerosCurso',
	GrucoevaluacionInternaPorIntegrante = 'GrucoevaluacionInternaPorIntegrante',
	GrucoevaluacionIntegrantesOtroEquipo = 'GrucoevaluacionIntegrantesOtroEquipo',
	GrucoevaluacionEntreEquipos = 'GrucoevaluacionEntreEquipos',
	GrucoevaluacionCompanerosCurso = 'GrucoevaluacionCompanerosCurso'
}

export enum ModoAplicacionEnum {
	heteroevaluacion = 'heteroevaluacion',
	autoevaluacion = 'autoevaluacion',
	coevaluacion = 'coevaluacion'
}

export enum TipoInstrumentoEnum {
	rubrica = 'rubrica',
	listaCotejo = 'listaCotejo',
	escalaValoracion = 'escalaValoracion',
	rubricaCualitativa = 'rubricaCualitativa'
}

export enum ModalidadEvaluacionProfesorEnum {
	global = 'global',
	individual = 'individual'
}

export const INSTRUMENTOS_PESO_BASE = { peso: 0, pesoKey: 'pesoBase' };

export const configuracionTablasInstrumento = {
	rubrica: {
		filas: [
			{
				'1': 'Dimensiones de evaluación / Niveles de logro',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Dimensiones de evaluación / Niveles de logro',
					'2': 'Por lograr',
					'3': 'Medianamente logrado',
					'4': 'Logrado',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	},
	listaCotejo: {
		filas: [
			{
				'1': 'Dimensiones de evaluación / Niveles de logro',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Dimensiones de evaluación / Niveles de logro',
					'2': 'No Observado',
					'3': 'Observado ',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	},
	escalaValoracion: {
		filas: [
			{
				'1': 'Dimensiones de evaluación / Niveles de logro',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true },
			{ title: '', dataIndex: 5, key: 5, editable: true },
			{ title: '', dataIndex: 6, key: 6, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true },
			{ title: '', dataIndex: 5, key: 5, editable: true },
			{ title: '', dataIndex: 6, key: 6, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Dimensiones de evaluación / Niveles de logro',
					'2': 'Insuficiente',
					'3': 'Satisfactorio',
					'4': 'Bueno',
					'5': 'Muy bueno',
					'6': 'Excelente',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	}
};

export const configuracionTablasInstrumentoEn = {
	rubrica: {
		filas: [
			{
				'1': 'Assessment Dimensions / Achievement Levels',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Assessment Dimensions / Achievement Levels',
					'2': 'Yet to achieve',
					'3': 'Partially achieved',
					'4': 'Achieved',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	},
	listaCotejo: {
		filas: [
			{
				'1': 'Assessment Dimensions / Achievement Levels',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Assessment Dimensions / Achievement Levels',
					'2': 'Not observed',
					'3': 'Observed',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	},
	escalaValoracion: {
		filas: [
			{
				'1': 'Assessment Dimensions / Achievement Levels',
				title: '',
				dataIndex: 1,
				key: 1,
				editable: true
			},
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true }
		],
		columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true },
			{ title: '', dataIndex: 5, key: 5, editable: true },
			{ title: '', dataIndex: 6, key: 6, editable: true }
		],
		puntaje_filas: [{ title: '', dataIndex: 1, key: 1, editable: true }],
		puntaje_columnas: [
			{ title: '', dataIndex: 1, key: 1, editable: true },
			{ title: '', dataIndex: 2, key: 2, editable: true },
			{ title: '', dataIndex: 3, key: 3, editable: true },
			{ title: '', dataIndex: 4, key: 4, editable: true },
			{ title: '', dataIndex: 5, key: 5, editable: true },
			{ title: '', dataIndex: 6, key: 6, editable: true }
		],
		rubrica_fill_table_filas: [
			{
				posicion_fila: 0,
				fila: {
					'1': 'Assessment Dimensions / Achievement Levels',
					'2': 'Insufficient',
					'3': 'Satisfactory',
					'4': 'Good',
					'5': 'Very good',
					'6': 'Excellent',
					title: '',
					dataIndex: 1,
					key: 1,
					editable: true,
					keyRegistro: '17442877-15c8-4c26-afa9-a1e1c582442a'
				}
			},
			{
				posicion_fila: 1,
				fila: {
					title: '',
					dataIndex: 2,
					key: 2,
					editable: true
				}
			},
			{
				posicion_fila: 2,
				fila: {
					title: '',
					dataIndex: 3,
					key: 3,
					editable: true
				}
			}
		]
	}
};
